import type { FaireProductEntity } from "../../entity_types/product";

export const p_ymufbfzhzd: FaireProductEntity = {
  token: "p_ymufbfzhzd",
  type: "product",
  name: "Evil Eye Protection Medallion Talisman 14K Gold Crystal Neck",
  brandToken: "b_sf3pyfue5x",
  brandName: "HoopLa",
  imageUrl:
    "https://cdn.faire.com/fastly/624f594c510a188a8419374bec66c196141234d2bd330de54d495f5db18af529.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/679b6bebc220ae3f0152fdee349b2456b3530b1ce6b48762802305f4eecb3bbe.jpeg",
    "https://cdn.faire.com/fastly/6cfc5ee604f9ae29febeda94f6ffdd40f092e088c7a6d6c4b9adf12aa3c30b5c.jpeg",
    "https://cdn.faire.com/fastly/266bcf3578a04511cc5be59fcb65a2d8320990f5cd4a98bd6188173bcc269aeb.jpeg",
    "https://cdn.faire.com/fastly/e1093ce64b996f52d37f66b6d14fed11a57117156d445bd3e0f84c4e6f022497.jpeg",
    "https://cdn.faire.com/fastly/fcc08b227b2f19070c4bb68ae6dd9649a936212288a324584191489e52242446.jpeg",
  ],
  priceDollars: 20.55,
  description:
    'Malacite Evil Eye Protection Rectangular pendant. On a Steel 14K Gold  Plated 18" Chain. Lobster Claw Clasp. Crystal Set Stones. Clear and Foil Backed for reflection. \nThis is a Wax Mold made Steel Piece. It is then dipped 3 times in 14K Gold. Hand set stones and Malachite Cabochon. \nThis is an ancient talisman of protection. \nWaterproof, Hypoallergenic, ',
  tags: [],
  msrpDollars: 41.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:54.968Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
